module.exports = __webpack_public_path__ + "skill_other.1332308a.svg";